var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpenLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3035_16250)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5 2C15.7044 2 14.9413 2.31607 14.3787 2.87868C13.8161 3.44129 13.5 4.20435 13.5 5V11C14.2956 11 15.0587 11.3161 15.6213 11.8787C16.1839 12.4413 16.5 13.2044 16.5 14V21.5C16.5 22.2956 16.1839 23.0587 15.6213 23.6213C15.0587 24.1839 14.2956 24.5 13.5 24.5H4.5C3.70435 24.5 2.94129 24.1839 2.37868 23.6213C1.81607 23.0587 1.5 22.2956 1.5 21.5V14C1.5 13.2044 1.81607 12.4413 2.37868 11.8787C2.94129 11.3161 3.70435 11 4.5 11H12V5C12 3.80653 12.4741 2.66193 13.318 1.81802C14.1619 0.974106 15.3065 0.5 16.5 0.5C17.6935 0.5 18.8381 0.974106 19.682 1.81802C20.5259 2.66193 21 3.80653 21 5V11C21 11.1989 20.921 11.3897 20.7803 11.5303C20.6397 11.671 20.4489 11.75 20.25 11.75C20.0511 11.75 19.8603 11.671 19.7197 11.5303C19.579 11.3897 19.5 11.1989 19.5 11V5C19.5 4.20435 19.1839 3.44129 18.6213 2.87868C18.0587 2.31607 17.2956 2 16.5 2Z",
    fill: "#1C2026"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3035_16250"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenLock);
export default __webpack_public_path__ + "static/media/open-lock.3428f655032b3f8749f29b919efab40e.svg";
export { ForwardRef as ReactComponent };